import { setSelectedEstimateItemIds } from '../State/selectedEstimateItemIds';

export default () => (dispatch) => {

  dispatch(setSelectedEstimateItemIds([]));

}